import { render, staticRenderFns } from "./ViqSlideOut.vue?vue&type=template&id=880dc7c2&scoped=true"
import script from "./ViqSlideOut.vue?vue&type=script&lang=js"
export * from "./ViqSlideOut.vue?vue&type=script&lang=js"
import style0 from "./ViqSlideOut.vue?vue&type=style&index=0&id=880dc7c2&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/@nuxt/webpack/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "880dc7c2",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/www/html/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('880dc7c2')) {
      api.createRecord('880dc7c2', component.options)
    } else {
      api.reload('880dc7c2', component.options)
    }
    module.hot.accept("./ViqSlideOut.vue?vue&type=template&id=880dc7c2&scoped=true", function () {
      api.rerender('880dc7c2', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "components/viq/ViqSlideOut.vue"
export default component.exports